export default function getFirstPartOfPath(path: string) {
  return path.split('/').length > 1 ? `/${path.split('/')[1]}` : '';
}
